class EnvironmentService {
  getEnvironment () {
    var hostName = window.location.hostname;

    if (hostName.includes('local')) {
      return 'Development';
    } else if (hostName.includes('dev')) {
      return 'Development';
    } else if (hostName.includes('qa')) {
      return 'QA';
    } else if (hostName.includes('po')) {
      return 'PO';
    } else if (hostName.includes('status.hawksoft.cloud')) {
      return 'Production';
    }

    return '<unable to determine user api url>';
  }
}

var x = new EnvironmentService();
export default x;
